import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { BillTosState } from "@insite/client-framework/Store/Data/BillTos/BillTosState";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { ShipTosState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { BillToCollectionModel, BillToModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";


const initialState: ShipTosState = {
    isLoading: {},
    byId: {},
    dataViews: {},
};

const reducer = {
    "Data/AddressBookShipTos/BeginLoadShipTos": (draft: Draft<ShipTosState>, action: { parameter: GetShipTosApiParameter }) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/AddressBookShipTos/CompleteLoadShipTos": (
        draft: Draft<ShipTosState>,
        action: { parameter: GetShipTosApiParameter; collection: ShipToCollectionModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => collection.shipTos!);
    },

    "Data/ShipTos/Reset": () => {
        return initialState;
    },

    "Data/BillTos/BeginLoadBillTos": (draft: Draft<BillTosState>, action: { parameter: GetBillTosApiParameter }) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/BillTos/CompleteLoadBillTos": (
        draft: Draft<BillTosState>,
        action: { parameter: GetBillTosApiParameter; collection: BillToCollectionModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => collection.billTos!);
    },

    "Data/AddressBookBillTos/Reset": () => {
        return initialState;
    },
};

const xAddressBook = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xAddressBook = xAddressBook;

export type xAddressBookState = {
    xAddressBookState: ShipTosState;
};

type xAddressBookReducers = {
    searchInputFocus: typeof xAddressBook;
    homePageMessage: typeof xAddressBook;
};

export type xAddressBookActions = Parameters<xAddressBookReducers[keyof xAddressBookReducers]>[1] | AnyAction;

export default createTypedReducerWithImmer(initialState, reducer);
